import { GroupingRule, WithTransactionId } from '@ardoq/api-types';
import { groupingRules$ } from 'streams/grouping/groupingRules$';
import { groupingRuleOperations } from '@ardoq/core';

type GetAll = () => GroupingRule[];

const getAll: GetAll = () =>
  groupingRules$.state.groupingRules.map(toInterfaceType);

const toInterfaceType = groupingRuleOperations.toGlobalTargetId;

const count = () => groupingRules$.state.groupingRules.length;

const getActiveGroupingRules = (): GroupingRule[] =>
  groupingRuleOperations.getValidRules(groupingRules$.state.groupingRules);

const getActiveGroupingAttributes = (): WithTransactionId & {
  groupingRules: GroupingRule[];
} => ({
  groupingRules: getActiveGroupingRules(),
  transactionId: groupingRules$.state.transactionId,
});

/**
 * `groupingRuleInterface` snapshots `groupingRules$.state` at call time.
 *
 * The app is stream-based now. Join `groupingRules$`
 * (`streams/grouping/groupingRules$.ts`) at a permitted boundary -- a `*$.ts`
 * file, a file inside a `*$/` folder, or a `*routines.ts` -- and thread the
 * resolved rules downstream as plain parameters. Pure logic belongs in
 * `groupingRuleOperations` (`@ardoq/core`) or `groupingUtils`
 * (`@ardoq/scope-data`).
 *
 * Every member below is deprecated. See
 * `packages/eslint-plugin-ardoq-lint/docs/rules/no-model-interface-call.md`
 * for the hoisting recipe.
 */
export const groupingRuleInterface = {
  /**
   * @deprecated Join `groupingRules$` and read `groupingRules`.
   */
  getAll,
  /**
   * @deprecated Call the pure `groupingUtils.enhanceTargetIdWithWorkspaceId` (`@ardoq/scope-data`) directly.
   */
  toInterfaceType,
  /**
   * @deprecated Join `groupingRules$` and read `groupingRules.length`.
   */
  count,
  /**
   * @deprecated Join `groupingRules$` and call `groupingRuleOperations.getValidRules(rules)` (`@ardoq/core`); the stream already carries the `transactionId`.
   */
  getActiveGroupingAttributes,
  /**
   * @deprecated Join `groupingRules$` and call `groupingRuleOperations.getValidRules(rules)` (`@ardoq/core`).
   */
  getActiveGroupingRules,
};
